import { defineStore } from 'pinia'

export const useMainStore = defineStore('main', {
  state: () => ({ urlParameters: undefined }),
})
